import React from 'react';
import { Button } from '../../../../../../../../../../CommonComponents/OPL/Button/Button';
import { Box } from '../../../../../../../../../../CommonComponents/OPL/Box/Box';
import { Checkbox } from '../../../../../../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { Dot } from '../../../../../../../../../../CommonComponents/OPL/Dot/Dot';
import { Text } from '../../../../../../../../../../CommonComponents/OPL/Text/Text';
import { TaxBracket } from '../../useRothConversionChart';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../../../../../../../../../CommonComponents/OPL/Popover/Popover';
import { formatPercentage } from '../../../../../../../../../../CommonUtils/formatNumber';

interface Props {
  triggerText: string;
  data: TaxBracket[];
  onChange(bracket: TaxBracket[]): void;
}

export const TaxBracketSelector: React.FC<Props> = ({ triggerText, data, onChange }) => {
  return (
    <Popover>
      <PopoverTrigger>
        <Button variant="subtleInactive" rightIcon="fas fa-caret-down" ml="4">
          {triggerText}
        </Button>
      </PopoverTrigger>

      <PopoverContent width={185}>
        {data.map(({ value, selected, color }, index) => (
          <Box key={value} p="8">
            <Checkbox
              checked={selected}
              onChange={evt =>
                onChange([
                  ...data.slice(0, index),
                  { ...data[index], selected: evt.target.checked },
                  ...data.slice(index + 1),
                ])
              }
            >
              <Box display="flex" alignItems="center">
                <Dot size={8} bg={color} mr="4" />
                <Text>{formatPercentage(value)}</Text>
              </Box>
            </Checkbox>
          </Box>
        ))}
      </PopoverContent>
    </Popover>
  );
};
